export type FileSelectorDocumentProps = React.HTMLAttributes<HTMLDivElement> & {
	onUpload: (file: FormData) => void
	uploaded: boolean
	clearFile?: string
	uploading?: boolean
}

type FileSelectorDocumentDefaultProps = {
	onUpload: (file: FormData) => void
	uploaded: boolean
	clearFile?: string
	uploading?: boolean
}

export const defaultProps: FileSelectorDocumentDefaultProps = {
	onUpload: () => { },
	uploaded: false,
	clearFile: "",
	uploading: false,
}
